export default class CreateProposalRecordError extends Error {
}
